import styled, { keyframes } from 'styled-components'

import { Column } from '../Grid'
import { Text } from '../Text'
import { NextImage } from '../NextImage'
import { ConsultationChecked } from '../Icons'

const ScheduleFeedback = ({ scheduledAmount }) => {
  return (
    <>
      {scheduledAmount === 0 ? (
        <Column height='100%' justifyContent='center' alignItems='center' background='white'>
          <FadeIn>
            <Text fontWeight='bold' variant='small'>
              Você selecionou todas as suas consultas!
            </Text>
            <NextImage src='/static/images/calendar-feedback.svg' width={200} height={200} />

            <Text width='320px' variant='small'>
              Se você já marcou todas as consultas que deseja, você já pode seguir com o pagamento
              para confirmar as consultas!
            </Text>
          </FadeIn>
        </Column>
      ) : (
        <Column height='100%' justifyContent='center' alignItems='center' background='white'>
          <CheckedIcon>
            <ConsultationChecked color='#27ae60' width='100%' height='100%' />
          </CheckedIcon>
          <Text fontWeight='bold' variant='small'>
            Consulta Selecionada com Sucesso!
          </Text>
        </Column>
      )}
    </>
  )
}

const pulse = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
    transform-origin: center;
  }
  100% {
    transform: scale(1);
    opacity: 1;
    transform-origin: center;
  }
`

const CheckedIcon = styled.div`
  width: 116px;
  height: 100px;
  animation: ${pulse} 1.5s;
  margin-bottom: 20px;
`

const fade = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`
const FadeIn = styled.div`
  opacity: 1;
  animation: ${fade} 1s ease-in;
`

export { ScheduleFeedback }
